import React, { Component } from 'react'
import {Toast} from 'antd-mobile';
import tools from '@/utils/tool';
import API from './../../config/api';
import httpRequest from '@/utils/httpRequest'
import './index.scss'
import Header from '@/components/Header/header'

// 实践所，实践基地列表
export default class index extends Component {
  constructor(props){
    super(props)
    this.state = {
      type:'', // 1:实践所街道列表  其他：实践基地列表
      uuid:'',
      data:[],
    }
  }

  componentDidMount(){
    // 获取参数
    let url = window.location.href
    let parameter =  tools.getParams(url)
    this.setState({
      type:parameter.type,
      uuid:parameter.uuid
    },() => {
      this.getList()
    })
  }

  getList = () => {
    const {type} = this.state
    httpRequest({
      url: type / 1 === 1 ? API.practiceList : API.practiceBaseList,
      type: 'get',
      data: {}
    }).done((resp) => {
      if (resp.code === 0) {
        this.setState({
          data:resp.data
        })
      } else {
        Toast.fail(resp.msg || resp.error);
      }
    }).fail(jqXHR => {
      Toast.fail(jqXHR.msg || jqXHR.error);
    })
  }

  handle_click = (type,data) => {
    let uuid = ''
    if(type / 1 === 1){
      uuid = data.street_id
    } else {
      uuid = data.base_id
    }
    this.props.history.push(`/civilizationListDetail?type=${type}&uuid=${uuid}`);
  }

  render() {
    const {data,type} = this.state
    return (
      <div>
        {/*头部*/}
			  <Header name={'home'} uuid={''}/>
        <div className='container'>
          {type / 1 === 1 ? // 实践所街道列表
            data.map((item,index) => {
              return <div key={index} className={`module ${type / 1 === 1? 'streetModule' : 'baseModule'}`}
                          onClick={this.handle_click.bind(this,'1',item)}>
                      <div className='imgBox'><img src={item.street_cover} alt=""/></div>
                      <div className="name limit-line2">{item.street_title}</div>
                    </div>
            })
          : // 实践基地列表
            data.map((item,index) => {
              return <div key={index} className={`module ${type / 1 === 1? 'streetModule' : 'baseModule'}`}
                          onClick={this.handle_click.bind(this,'2',item)}>
                      <div className="name">{item.base_title}</div>
                    </div>
            })
          }  
        </div>
      </div>
      
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/CivilizationList/index.js